import styled from '@emotion/styled';
import { ModalContainer, UIcon, IconContainer } from '../Modal/CreateAdminUser';
import { convertTimetoString } from '../../../../helperFunction';
import {useState} from 'react';
import {BsThreeDotsVertical as MoreDots} from 'react-icons/bs';

const ViewDetails = (props: any) => {
  const data = props.data;
  const [showDisable,setShowDisable] = useState<boolean>(false);

  return (
    <ModalContainer>
      <div>
        <div>
          <div>
            <IconContainer><UIcon /></IconContainer>
            <span>{data.ClassificationType}</span>

          </div> 
          {/* <MoreContainer>
              <span onClick={()=>setShowDisable(!showDisable)}><MoreDots/></span>
              <div className={showDisable?'show':''}>
                  <span onClick={()=>{}}>Disable</span>
              </div>
          </MoreContainer> */}

        </div>
        
        <MainContainer>
          <p style={{width:'100%',fontWeight:'bold'}}>Details</p>
          <div>
            <span>Status</span>
            <span style={!data.ActiveStatus?{color:'red',backgroundColor:"lightpink"}:{}}>{data.ActiveStatus?'Active':'disabled'}</span>
          </div>
          <div>
            <span>Classification</span><span>{data?.ClassificationType}</span>
          </div>
          <div>
            <span>Sector</span><span>{data?.SectorType}</span>
          </div>
          <div>
            <span>Annual Subscription</span><span>{(data?.AnnualSubscription) }</span>
          </div>
          <div>
          </div>
         
        </MainContainer>
      </div>
    </ModalContainer>
  )
}

export default ViewDetails;

const MoreContainer = styled.div`
    position: relative;
    
    & > span{
        cursor: pointer;
    }
    & > div{
        display:none;
        flex-direction: column;
        min-width: 120px;
        padding: 10px 0;
        background-color: #f9f9f9;
        position: absolute;
        right:0;
        top:35px;
        border:1px solid #eee;
    }
    & > div.show{
        display: flex !important;
    }
    
    & > div > span{
        padding:10px;
        background-color: transparent;
        display:inline-block;
        width:100%;
        color:#222;
        cursor: pointer;
        font-size:12px;
    }
    & > div > span:hover{
        background-color:#eee
    }

`

const MainContainer = styled.div`
  background-color: #fff;;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:20px;
  padding:30px;

  & > div:first-of-type > span:last-of-type{
    padding: 6px 10px;
    color:#11643C;
    background-color:#E0FAEE;
    border-radius: 3px;
  }

  & > div{
    flex:1;
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  
  & > div > span:first-of-type{
    color:#4E5A62;
  }
  
`